<template>
  <div>
    <!-- data table -->
    <!-- eslint-disable -->
    <auth v-if="mounted"></auth>
    <v-data-table
      :headers="headers"
      :items="logs"
      sort-by="date"
      class="data-table elevation-1 mt-md-3 mt-16"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Training Reports</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <!-- <v-btn to="/home">home.vue</v-btn> -->
          <!-- <v-btn to="/data_table">data table.vue</v-btn> -->
          <v-btn color="primary" dark class="mb-2" to="/trainingReport_add"
            >Add New Report</v-btn
          >
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="pa-3" @click="editItem(item)">$edit</v-icon>
        <v-icon class="pa-3" @click="deleteItem(item)">$del</v-icon>
      </template>

      <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Reset </v-btn>
    </template> -->
    </v-data-table>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .data-table {
    width: 96%;
    margin: 0 auto;
  }

  .add-to-roster {
    height: 500px;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
import auth from "./auth.vue";
export default {
  name: "training_reports",
  components: {
    banner,
    auth,
  },
  mixins: [bus_common],

  data: () => ({
    mounted: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Officer",
        align: "left",
        sortable: true,
        value: "reporting_officer",
      },
      {
        text: "Specialty",
        align: "left",
        sortable: true,
        value: "select_specialty",
      },
      { text: "Date", align: "left", sortable: true, value: "trn_date" },
      { text: "Time", align: "left", sortable: true, value: "trn_time" },
      { text: "Actions", value: "actions", sortable: false },
    ],

    // logs: [
    //   {
    //     training_name: "Smith",
    //     training_specialty: "Explosive Breaching AARs",
    //     training_date: "01/01/2024",
    //     training_casenum: "24-00023",
    //     training_time: "13:00",
    //   },
    //   {
    //     training_name: "Jones",
    //     training_specialty: "Sniper AARs",
    //     training_date: "03/01/2024",
    //     training_casenum: "24-00024",
    //     training_time: "09:00",
    //   },
    //   {
    //     training_name: "Barnes",
    //     training_specialty: "Ropes AArmRs",
    //     training_date: "06/01/2024",
    //     training_casenum: "24-00025",
    //     training_time: "23:00",
    //   },
    // ],
    logs: [],
    editedIndex: -1,

    /* editItems */
    editedItem: {
      officer: "",
      specialty: "",
      date: "",
      casenum: "",
      time: "",
    },
    defaultItem: {
      officer: "",
      specialty: "",
      date: "",
      casenum: "",
      time: "",
    },

    formIn: {
      officer: "",
      specialty: "",
      date: "",
      casenum: "",
      time: "",
    },

    training_names: [
      "Autry",
      "Baehr",
      "Butler",
      "Chang",
      "Christensen, B",
      "Clifford",
      "Donigan",
      "Dougherty",
      "Duralde",
      "Espinoza, A",
      "Hakin",
      "Hanna",
      "Hendrix",
      "Hogan",
      "Hoyt",
      "Kent",
      "Kerfoot",
      "Lancaster",
      "Lopey",
      "Mathiowetz",
      "Meseberg",
      "Perham, J",
      "Robles",
      "Rousseau",
      "Schaur",
      "Schmidt",
      "Smith",
      "Sotelo",
      "Struffert",
      "Tom",
      "Tone",
      "Waasdorp",
      "Williams",
      "Ziese",
    ],

    /* STOPPED HERE - NEED TO FINISH CHANGING FIELD NAMES, ETC FOR ADD FORM */

    training_specialties: [
      "Explosive Breaching AARs",
      "Sniper AARs",
      "Ropes AArmRs",
      "Team training AARs",
      "Mission AARs",
    ],
    training_dates: [],
    training_casenums: [],
    training_times: [],
    deleteID: 0,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Roster/Assignment" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    // this.initialize();
  },

  methods: {
    editItem(item) {
      // this.editedIndex = this.logs.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      // this.dialog = true;
      this.$router.push({
        name: "trainingReport_add",
        params: { id: item.train_repId },
      });

      // name: 'detail', // Replace 'detail' with your route name
      //   params: {
      //     id: this.itemId
      //   }
    },
    deleteItem(item) {
      this.deleteID = item.train_repId;
      let self = this;
      this.swall_diag(
        "Confirm Delete Report",
        "Do you wish to delete the report created by " +
          item.reporting_officer +
          " on " +
          this.format_date_us(item.s_CreateDate) +
          "?",
        "question",
        function () {
          self.deleteNow();
        },
        null,
        null,
        function () {
          //no
        }
      );
    },

    deleteNow() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.deleteID = this.deleteID;

      formIn.apiname = "deleteNowTrainRep";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.get_training_reps();
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      /* if (this.editedIndex > -1) {
        Object.assign(this.fullroster[this.editedIndex], this.editedItem);
      } else { */
      this.logs.push(this.formIn);
      /* } */
      this.close();
    },

    message1() {
      alert("This button does nothing yet.");
    },

    get_training_reps() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_training_reps";
      var self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.logs = self.mno(data);
          for (let index = 0; index < self.logs.length; index++) {
            const element = self.logs[index];
            let dt = element.trn_date;
            //   console.log("dt: " + dt);
            element.trn_date = self.format_date_us(dt);
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    init() {
      this.mounted = true;
      this.get_training_reps();
    },
  },

  mounted() {
    this.$nextTick(() => {
      let lstlinks = document.querySelectorAll(".menulink");
      console.log("lengths: " + lstlinks.length);
      for (let index = 0; index < lstlinks.length; index++) {
        const element = lstlinks[index];
        element.style.color = "white";
      }
      document.getElementById("trainlink").style.color = "orange";
      this.init();
    });
  },
};
</script>
